import React from "react"
import { TextField } from "@material-ui/core"

import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"

import useConditionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useConditionEditor"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import { getMessageReceivedCondition } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type ButtonSectionEditorProps = {
	onSave: (chatBotFlowBlockRule: ChatBotFlowBlockRule) => void
	onDelete?: () => void
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	hideChildSelection?: boolean
	disabled?: boolean
}

const ButtonSectionEditor: React.FC<ButtonSectionEditorProps> = (props) => {
	const {
		onSave,
		chatBotFlowBlockRule,
		children,
		hideChildSelection,
		onDelete,
		disabled
	} = props

	const messageReceivedCondition = getMessageReceivedCondition([chatBotFlowBlockRule])
	const conditionEditor = useConditionEditor({ chatBotFlowBlockRule })

	if (!messageReceivedCondition) {
		return null
	}

	return (
		<BlockBodySectionEditor
			title="BOTÃO"
			onSave={() => onSave(conditionEditor.rule)}
			onOpen={conditionEditor.reset}
			onDelete={onDelete}
			hideChildSelection={hideChildSelection}
			disabled={disabled}
			AsideDrawerProps={{
				children: (
					<TextField
						variant="outlined"
						placeholder="Nome do botão"
						value={conditionEditor.retrieveValidationValue(messageReceivedCondition.validationIndex)}
						onChange={(event) => conditionEditor.changeValidationValue(messageReceivedCondition.validationIndex, event.target.value)}
						fullWidth
					/>
				)
			}}
			DeletePopConfirmProps={{
				title: "Excluir botão",
				description: "Tem certeza? Essa ação é irreversível.",
				confirmButtonText: "EXCLUIR"
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default ButtonSectionEditor
